import { useState } from 'react';
import { useSetOffsetMutation } from '../../api/mutations';
import type { GroupName } from '../../domain';

export function OffsetControl({ group, current }: { group: GroupName; current: number }) {
  const [value, setValue] = useState(current);
  const mutation = useSetOffsetMutation();

  const disabled = mutation.isPending || value === current;
  return (
    <div className="setpoint-row">
      <label className="label" htmlFor={`offset-${group}`}>Offset</label>
      <input
        id={`offset-${group}`}
        type="number"
        step="0.1"
        min={-5}
        max={5}
        value={value}
        onChange={(e) => setValue(parseFloat(e.target.value))}
        aria-label={`offset for ${group}`}
      />
      <span className="muted">°C</span>
      <button onClick={() => mutation.mutate({ group, offset_c: value })} disabled={disabled}>
        {mutation.isPending ? 'Saving…' : 'Save'}
      </button>
      {mutation.isError && <span className="field-error">{(mutation.error as Error).message}</span>}
    </div>
  );
}
